module.exports = __webpack_public_path__ + "static/media/Circle-white.3d17d757.svg";